/* Memorial · UX 06 (13-oct-2026)
   3) "De parte de" ya no bloquea "Añadir al carrito": si el cliente no lo completa en la ficha,
      se le pide en el carrito (lateral y /cart), por arreglo, antes de "Finalizar compra".
      Se guarda en la misma propiedad del pedido ("De parte de"), así la tarjeta sale igual.
   4) "Comprar por WhatsApp" pasa a ser un enlace secundario debajo de "Añadir al carrito".
   Eventos GA4: mm_compra_bloqueada {motivo: 'Carrito: falta de parte de quién'} y
   mm_personaliza {campo: 'envia', valor: 'completado_carrito'} (nunca se envía el nombre).
*/
(function () {
  'use strict';

  var PROP = 'De parte de';
  var K_SS = 'mm_envia_v1';
  var NOTA_FICHA = 'Nombre o familia que envía el arreglo. Si prefieres, lo indicas en el carrito antes de pagar.';

  function ev(nombre, datos) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: nombre };
    for (var k in datos) if (Object.prototype.hasOwnProperty.call(datos, k)) o[k] = datos[k];
    window.dataLayer.push(o);
  }
  function limpio(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* ---------- Estilos ---------- */
  function estilos() {
    if (document.getElementById('mm-envia-css')) return;
    var s = document.createElement('style');
    s.id = 'mm-envia-css';
    s.textContent =
      /* Campo "De parte de" en el carrito */
      '.mm-envia{margin:10px 0 4px;padding:10px 12px;border-radius:10px;background:#F4F1E8;border:1px solid #E5E1D1}' +
      '.mm-envia label{display:block;margin:0 0 6px;font-size:14px;font-weight:600;color:#172B21}' +
      '.mm-envia label span{font-weight:400;color:#6b6b60}' +
      '.mm-envia input{width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #857f70;border-radius:8px;background:#fff;color:#172B21;font-size:16px;line-height:1.3}' +
      '.mm-envia input:focus{outline:2px solid #29371C;outline-offset:1px}' +
      '.mm-envia__nota{margin:6px 0 0;font-size:12px;line-height:1.35;color:#6b6b60}' +
      '.mm-envia__error{display:none;margin:6px 0 0;font-size:13px;font-weight:600;color:#b3261e}' +
      '.mm-envia.is-error{border-color:#b3261e;background:#fdf3f2}' +
      '.mm-envia.is-error input{border-color:#b3261e;box-shadow:0 0 0 2px rgba(179,38,30,.15)}' +
      '.mm-envia.is-error .mm-envia__error{display:block}' +
      '.mm-envia-guardando{opacity:.7;pointer-events:none;cursor:progress}' +
      '.mm-envia__usar{display:inline-flex;align-items:center;min-height:44px;margin:4px 0 0;padding:0 12px;border:1px solid #857f70;border-radius:999px;background:#fff;color:#172B21;font:inherit;font-size:13px;cursor:pointer}' +
      '.mm-envia__usar:hover{border-color:#172B21}' +
      '.mm-envia__usar[hidden]{display:none}' +
      /* WhatsApp como enlace secundario */
      '.product-form__buttons.mm-wa-compra{display:flex!important;justify-content:center;margin:10px 0 0!important;padding:0!important;background:none!important;border:0!important}' +
      '.mm-wa-compra a.mm-wa-btn{display:inline-flex!important;align-items:center;justify-content:center;gap:6px;width:auto!important;min-height:44px!important;height:auto!important;padding:10px 12px!important;' +
      'background:none!important;border:0!important;box-shadow:none!important;border-radius:0!important;color:#172B21!important;font-size:14px!important;font-weight:500!important;' +
      'text-transform:none!important;letter-spacing:0!important;text-decoration:underline!important;text-underline-offset:3px}' +
      '.mm-wa-compra a.mm-wa-btn:hover{color:#29371C!important;background:none!important}' +
      '.mm-wa-compra a.mm-wa-btn svg{width:18px!important;height:18px!important;color:#1f8a4c;flex:0 0 auto}';
    document.head.appendChild(s);
  }

  /* ================= FICHA DE PRODUCTO ================= */
  function iniciarFicha() {
    if (!document.body.classList.contains('template-product')) return;

    // Texto del campo: ahora es opcional en la ficha
    var dp = document.getElementById('de-parte-de');
    if (dp) {
      dp.removeAttribute('aria-required');
      dp.removeAttribute('required');
      var nota = document.querySelector('.mm-departe-nota');
      if (nota) nota.textContent = NOTA_FICHA;
      var lab = document.querySelector('label[for="de-parte-de"]');
      if (lab && !lab.querySelector('.mm-opcional')) {
        var op = document.createElement('span');
        op.className = 'mm-opcional';
        op.style.fontWeight = '400';
        op.textContent = ' (opcional aquí)';
        lab.appendChild(op);
      }
    }

    // La barra fija de celular ya no lleva a "De parte de": añade al carrito directamente.
    // (mm-mejoras.js 3e la desviaba a ese campo; este aviso corre antes, en la fase de captura de window.)
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.mm-sticky-bar__btn');
      if (!b) return;
      var atc = document.getElementById('add-to-cart-btn');
      var base = document.querySelector('select[name="properties[Base]"]');
      var campo = document.getElementById('de-parte-de');
      if (!atc || atc.disabled) return;          // falta fecha/horario: lo maneja la barra
      if (base && !base.value) return;            // falta base: lo maneja mm-mejoras 3e
      if (!campo || limpio(campo.value)) return;  // nada que cambiar
      e.preventDefault();
      e.stopImmediatePropagation();
      ev('sticky_bar_click', { accion: 'agregar_al_carrito' });
      atc.click();
    }, true);
  }

  /* ================= CARRITO ================= */
  var valores = {};
  try { valores = JSON.parse(sessionStorage.getItem(K_SS)) || {}; } catch (e) { valores = {}; }
  function guardarLocal() { try { sessionStorage.setItem(K_SS, JSON.stringify(valores)); } catch (e) {} }

  var cart = null;
  var cargando = null;

  function cargarCarrito() {
    if (cargando) return cargando;
    cargando = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; cargando = null; return c; })
      .catch(function () { cargando = null; return null; });
    return cargando;
  }

  // Arreglos personalizados (con fecha o tarjeta) que todavía no tienen "De parte de"
  function necesita(item) {
    var p = item.properties || {};
    var esArreglo = p['Fecha de entrega'] != null || p['Diseño de dedicatoria'] != null || p['Horario de entrega'] != null;
    return esArreglo && !limpio(p[PROP]);
  }

  function contenedores() {
    var res = [];
    document.querySelectorAll('[data-minimog-cart-items]').forEach(function (cont) {
      var lista = cont.querySelector('.m-cart-drawer__items, .m-cart__items');
      if (lista) res.push(lista);
    });
    return res;
  }

  function itemsDe(lista) {
    var items = lista.querySelectorAll('[data-cart-item]');
    return items.length ? Array.prototype.slice.call(items) : Array.prototype.slice.call(lista.children);
  }

  function otroNombre(clave) {
    if (!cart) return '';
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.key === clave) continue;
      var v = limpio((it.properties || {})[PROP]) || limpio(valores[it.key]);
      if (v) return v;
    }
    return '';
  }

  function bloque(item) {
    var d = document.createElement('div');
    var id = 'mm-envia-' + Math.random().toString(36).slice(2, 8);
    d.className = 'mm-envia';
    d.setAttribute('data-mm-envia', item.key);
    d.innerHTML =
      '<label for="' + id + '">De parte de <span>(obligatorio · va en la tarjeta)</span></label>' +
      '<input id="' + id + '" type="text" maxlength="60" autocomplete="off" autocapitalize="words" enterkeyhint="done" ' +
      'aria-required="true" aria-describedby="' + id + '-nota ' + id + '-err" ' +
      'placeholder="Ej.: Familia Pérez Rojas" value="' + esc(valores[item.key] || '') + '">' +
      '<button type="button" class="mm-envia__usar" hidden></button>' +
      '<p class="mm-envia__nota" id="' + id + '-nota">Nombre o familia que envía el arreglo.</p>' +
      '<p class="mm-envia__error" id="' + id + '-err" role="alert">Escribe de parte de quién es el arreglo para continuar al pago.</p>';
    var input = d.querySelector('input');
    var usar = d.querySelector('.mm-envia__usar');
    var marcado = false;
    function limpiarError() { d.classList.remove('is-error'); input.removeAttribute('aria-invalid'); }
    input.addEventListener('input', function () {
      valores[item.key] = input.value;
      guardarLocal();
      if (limpio(input.value)) limpiarError();
      sugerir();
    });
    // Evita volver a escribir: si otro arreglo del pedido ya tiene nombre, se ofrece con un toque (no se rellena solo)
    function sugerir() {
      var otro = otroNombre(item.key);
      if (otro && !limpio(input.value)) { usar.textContent = 'Usar el mismo: ' + otro; usar.hidden = false; usar.setAttribute('data-v', otro); }
      else usar.hidden = true;
    }
    usar.addEventListener('click', function () {
      input.value = usar.getAttribute('data-v') || '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    d._mmSugerir = sugerir;
    sugerir();
    input.addEventListener('change', function () {
      if (limpio(input.value) && !marcado) { marcado = true; ev('mm_personaliza', { campo: 'envia', valor: 'completado_carrito' }); }
      document.querySelectorAll('.mm-envia').forEach(function (b) { if (b !== d && b._mmSugerir) b._mmSugerir(); });
    });
    // Evita que Enter envíe el formulario del carrito (que actualiza cantidades)
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
    return d;
  }

  function colocar() {
    if (!cart) return;
    contenedores().forEach(function (lista) {
      var els = itemsDe(lista);
      els.forEach(function (el, i) {
        var item = cart.items[i];
        if (!item) return;
        var actual = el.querySelector('[data-mm-envia]');
        if (!necesita(item)) { if (actual) actual.remove(); el.setAttribute('data-mm-envia-ok', item.key); return; }
        if (actual && actual.getAttribute('data-mm-envia') === item.key) { el.setAttribute('data-mm-envia-ok', item.key); return; }
        if (actual) actual.remove();
        var destino = el.querySelector('.m-cart-item__info, .m-cart-drawer-item__info') || el;
        var precio = destino.querySelector('.m-cart-item__price');
        var b = bloque(item);
        if (precio) precio.insertAdjacentElement('beforebegin', b); else destino.appendChild(b);
        el.setAttribute('data-mm-envia-ok', item.key);
      });
    });
  }

  // ¿Hay items dibujados que aún no revisamos? (el carrito se volvió a dibujar)
  function hayNuevos() {
    var nuevos = false;
    contenedores().forEach(function (lista) {
      itemsDe(lista).forEach(function (el) { if (!el.hasAttribute('data-mm-envia-ok')) nuevos = true; });
    });
    return nuevos;
  }

  var tRevisar;
  function revisar() {
    clearTimeout(tRevisar);
    tRevisar = setTimeout(function () {
      if (!hayNuevos()) return;
      cargarCarrito().then(colocar);
    }, 200);
  }

  /* ---------- "Finalizar compra": exige el dato y lo guarda en el pedido ---------- */
  var enviando = false;

  function pendientes() {
    if (!cart) return [];
    var res = [];
    cart.items.forEach(function (item, i) {
      if (necesita(item)) res.push({ item: item, linea: i + 1, valor: limpio(valores[item.key]) });
    });
    return res;
  }

  function marcarFaltantes(faltan) {
    var primero = null;
    faltan.forEach(function (f) {
      document.querySelectorAll('[data-mm-envia="' + f.item.key.replace(/"/g, '') + '"]').forEach(function (b) {
        if (b.offsetParent === null) return; // solo el visible
        b.classList.add('is-error');
        var ib = b.querySelector('input'); if (ib) ib.setAttribute('aria-invalid', 'true');
        if (!primero) primero = b;
      });
    });
    if (primero) {
      primero.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var inp = primero.querySelector('input');
      setTimeout(function () { if (inp) inp.focus({ preventScroll: true }); }, 350);
    }
  }

  function guardarEnPedido(lista) {
    // Una línea a la vez: /cart/change.js reemplaza todas las propiedades, por eso se envían completas
    return lista.reduce(function (prom, f) {
      return prom.then(function () {
        var props = {};
        var orig = f.item.properties || {};
        for (var k in orig) if (Object.prototype.hasOwnProperty.call(orig, k) && orig[k] != null) props[k] = orig[k];
        props[PROP] = f.valor;
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: f.linea, quantity: f.item.quantity, properties: props })
        }).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
          .then(function (c) { cart = c; });
      });
    }, Promise.resolve());
  }

  function continuar(boton) {
    var form = boton.form || (boton.getAttribute('form') && document.getElementById(boton.getAttribute('form'))) || boton.closest('form');
    if (form) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
      form.appendChild(h);
      HTMLFormElement.prototype.submit.call(form); // no vuelve a disparar este control
    } else {
      window.location.href = '/checkout';
    }
  }

  function alPagar(e) {
    var boton = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    if (!boton || enviando) return;
    if (boton.disabled) return; // términos sin aceptar, etc.

    e.preventDefault();
    e.stopImmediatePropagation();

    cargarCarrito().then(function () {
      var lista = pendientes();
      if (!lista.length) { enviando = true; continuar(boton); return; }

      var faltan = lista.filter(function (f) { return !f.valor; });
      if (faltan.length) {
        colocar();
        marcarFaltantes(faltan);
        ev('mm_compra_bloqueada', { motivo: 'Carrito: falta de parte de quién' });
        return;
      }

      enviando = true;
      boton.classList.add('mm-envia-guardando');
      boton.setAttribute('aria-busy', 'true');
      var txt = boton.querySelector('span') || boton;
      if (txt.textContent) txt.textContent = 'Guardando datos…';
      guardarEnPedido(lista).then(function () {
        lista.forEach(function (f) { delete valores[f.item.key]; });
        guardarLocal();
        continuar(boton);
      }).catch(function () {
        // Si algo falla al guardar, no bloqueamos la venta: seguimos al pago
        continuar(boton);
      });
    });
  }

  function iniciarCarrito() {
    estilos();
    document.addEventListener('click', alPagar, true);
    // Enter dentro del carrito con el botón de pago enfocado, o envío del formulario por otra vía
    document.addEventListener('submit', function (e) {
      var s = e.submitter;
      if (s && s.name === 'checkout') alPagar({ target: s, preventDefault: function () { e.preventDefault(); }, stopImmediatePropagation: function () { e.stopImmediatePropagation(); } });
    }, true);

    if (contenedores().length) cargarCarrito().then(colocar);
    var pend = false;
    new MutationObserver(function () {
      if (pend) return;
      pend = true;
      requestAnimationFrame(function () { pend = false; revisar(); });
    }).observe(document.body, { childList: true, subtree: true });

    // Al agregar un producto el carrito cambia: forzar recarga la próxima vez
    document.addEventListener('cart:refresh', function () { cart = null; revisar(); });
  }

  function iniciar() {
    estilos();
    iniciarFicha();
    iniciarCarrito();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
